import { Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import { MODE } from "helpers/sf_constants";
import NumberFormat from "react-number-format";
import { optionsGarageType, optionsPrimaryUse, optionsVehicleOwnership } from "helpers/sf_lead_constants";


const AddVehicleModal = ({ title, leadApplicants, show, onClickSaveDriver, onCloseClick }) => {

    const [optionsDrivers, setOptionsDrivers] = useState([])

    useEffect(() => {
        if (leadApplicants) {
            const options = leadApplicants.map(LA => ({ label: `${LA.first_name} ${LA.last_name}`, value: LA.id }))
            setOptionsDrivers(options)
        }
    }, [leadApplicants])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            lead_applicant_id: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsDrivers, show?.values?.lead_applicant_id) : null,
            year: show?.mode === MODE.EDIT ? show?.values?.year : "",
            make: show?.mode === MODE.EDIT ? show?.values?.make : "",
            model: show?.mode === MODE.EDIT ? show?.values?.model : "",
            trim: show?.mode === MODE.EDIT ? show?.values?.trim : "",
            vin: show?.mode === MODE.EDIT ? show?.values?.vin : "",
            primary_use: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsPrimaryUse, show?.values?.primary_use) : null,
            sub_model: show?.mode === MODE.EDIT ? show?.values?.sub_model : "",
            ownership_status: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsVehicleOwnership, show?.values?.ownership_status) : null,
            garage_type: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsGarageType, show?.values?.garage_type) : null,
            annual_mileage: show?.mode === MODE.EDIT ? show?.values?.annual_mileage : ""
        },
        validationSchema: Yup.object({
            primary_use: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
              }),
            ownership_status: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
              }),
            garage_type: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
              }),
            lead_applicant_id: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
              }),
        }),
        onSubmit: (values) => {
            onClickSaveDriver(show?.mode, {
                ...values,
                lead_applicant_id: values.lead_applicant_id.value,
                primary_use: values.primary_use.value,
                garage_type: values.garage_type.value,
                ownership_status: values.ownership_status.value
            });
        },
    });
    return (
        <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='xl'>
            <ModalHeader>
                <div className="d-flex justify-content-center">
                    <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
                    <span className="modal-title font-weight-semibold text-black">
                        {title}
                    </span>
                </div>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onCloseClick}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit()
                        return false
                    }}
                >
                    <Row className="mx-2">
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Driver</Label>
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        options={optionsDrivers}
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: 'lead_applicant_id',
                                                    value: selectedOption,
                                                },
                                            };
                                            validation.handleChange(event);
                                        }}
                                        onBlur={() => {
                                            validation.handleBlur({
                                                target: { name: 'lead_applicant_id' },
                                            });
                                        }}
                                        value={validation.values.lead_applicant_id || ''}
                                        invalid={
                                            !!(validation.touched.lead_applicant_id
                                                && validation.errors.lead_applicant_id)
                                        }
                                    />
                                 {validation.touched.lead_applicant_id
                                    && validation.errors.lead_applicant_id ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Year</Label>
                                <NumberFormat
                                    type="text"
                                    name="year"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.year || ''}
                                    invalid={
                                        !!(validation.touched.year
                                            && validation.errors.year)
                                    }
                                />
                                {validation.touched.year
                                    && validation.errors.year ? (
                                    <span className="text-danger">
                                        {validation.errors.year}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Make</Label>
                                <Input
                                    type="text"
                                    name="make"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.make || ''}
                                    invalid={
                                        !!(validation.touched.make
                                            && validation.errors.make)
                                    }
                                />
                                {validation.touched.make
                                    && validation.errors.make ? (
                                    <span className="text-danger">
                                        {validation.errors.make}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Model</Label>
                                <Input
                                    type="text"
                                    name="model"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.model || ''}
                                    invalid={
                                        !!(validation.touched.model
                                            && validation.errors.model)
                                    }
                                />
                                {validation.touched.model
                                    && validation.errors.model ? (
                                    <span className="text-danger">
                                        {validation.errors.model}
                                    </span>
                                ) : null}
                            </Col>
                        </Col>
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Vehicle Usage</Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsPrimaryUse}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'primary_use',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'primary_use' },
                                        });
                                    }}
                                    value={validation.values.primary_use || null}
                                    invalid={
                                        !!(validation.touched.primary_use
                                            && validation.errors.primary_use)
                                    }
                                />
                                {validation.touched.primary_use
                                    && validation.errors.primary_use ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Sub Model</Label>
                                <Input
                                    type="text"
                                    name="sub_model"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.sub_model || ''}
                                    invalid={
                                        !!(validation.touched.sub_model
                                            && validation.errors.sub_model)
                                    }
                                />
                                {validation.touched.sub_model
                                    && validation.errors.sub_model ? (
                                    <span className="text-danger">
                                        {validation.errors.sub_model}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Ownership</Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsVehicleOwnership}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'ownership_status',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'ownership_status' },
                                        });
                                    }}
                                    value={validation.values.ownership_status || null}
                                    invalid={
                                        !!(validation.touched.ownership_status
                                            && validation.errors.ownership_status)
                                    }
                                />
                                {validation.touched.ownership_status
                                    && validation.errors.ownership_status ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                        </Col>
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">VIN</Label>
                                <Input
                                    type="text"
                                    name="vin"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.vin || ''}
                                    invalid={
                                        !!(validation.touched.vin
                                            && validation.errors.vin)
                                    }
                                />
                                {validation.touched.vin
                                    && validation.errors.vin ? (
                                    <span className="text-danger">
                                        {validation.errors.vin}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Garage</Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsGarageType}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'garage_type',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'garage_type' },
                                        });
                                    }}
                                    value={validation.values.garage_type || null}
                                    invalid={
                                        !!(validation.touched.garage_type
                                            && validation.errors.garage_type)
                                    }
                                />
                                {validation.touched.garage_type
                                    && validation.errors.garage_type ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Miles Per Year</Label>
                                <NumberFormat
                                    type="text"
                                    name="annual_mileage"
                                    thousandSeparator
                                    className="form-control"
                                    onChange={(event) => {
                                        const value = event.target.value.replace(",", "");
                                        validation.handleChange({ ...event, 
                                          target: { 
                                            ...event.target, 
                                            value: value, 
                                            name: 'annual_mileage' 
                                          } 
                                        })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.annual_mileage || ''}
                                    invalid={
                                        !!(validation.touched.annual_mileage
                                            && validation.errors.annual_mileage)
                                    }
                                />
                                {validation.touched.annual_mileage
                                    && validation.errors.annual_mileage ? (
                                    <span className="text-danger">
                                        {validation.errors.annual_mileage}
                                    </span>
                                ) : null}
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-end mt-3">
                            <button
                                type="submit"
                                name="submit"
                                className={`btn ${getPrimaryButtonClass()} ms-2`}
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                className="btn btn-light ms-2"
                                onClick={onCloseClick}
                            >
                                Cancel
                            </button>
                        </div>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

AddVehicleModal.propTypes = {
    onCloseClick: PropTypes.func,
    onClickSaveDriver: PropTypes.func,
    show: PropTypes.any,
    title: PropTypes.any,
}

export default AddVehicleModal;

